"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var types = {
  "pdf": {
    extensions: ["pdf"],
    icon: "fal fa-file-pdf"
  },
  "image": {
    extensions: ["jpg", "jpeg", "png", "bmp", "svg", "gif"],
    icon: "fal fa-file-image"
  },
  "word": {
    extensions: ["doc", "docx"],
    icon: "fal fa-file-word"
  },
  "excel": {
    extensions: ["xls", "xlsx"],
    icon: "fal fa-file-excel"
  },
  "powerpoint": {
    extensions: ["ppt", "pptx"],
    icon: "fal fa-file-powerpoint"
  },
  "archive": {
    extensions: ["zip", "tar", "tgz", "gz"],
    icon: "fal fa-file-archive"
  },
  "video": {
    extensions: ["divx", "mp4", "mpeg4"],
    icon: "fal fa-file-video"
  },
  "msg": {
    extensions: ["msg", "eml"],
    icon: "fal fa-envelope"
  },
  "unknow": {
    extensions: [],
    icon: "fal fa-file-alt"
  }
};
var buildIconMap = function buildIconMap() {
  var map = [];
  _.each(types, function (type) {
    _.each(type.extensions, function (ext) {
      return map[ext] = type.icon;
    });
  });
  return map;
};
var extensionToIcon = buildIconMap();
ngModule.factory("fileUtils", function (iconUtils) {
  return {
    getExtension: function getExtension(filename) {
      var splits = filename.split(".");
      if (splits.length > 1) {
        return splits[splits.length - 1].toLowerCase();
      }
      return filename;
    },
    getPdfExtensions: function getPdfExtensions() {
      return types.pdf.extensions;
    },
    getImagesExtensions: function getImagesExtensions() {
      return types.image.extensions;
    },
    getMsgExtensions: function getMsgExtensions() {
      return types.msg.extensions;
    },
    getExtensionIcon: function getExtensionIcon(extension) {
      return iconUtils.getFullName(extensionToIcon[extension] || types.unknow.icon);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/fileUtils.js
// module id = 2754
// module chunks = 13